import { useHistory } from 'react-router-dom'
import { client } from 'src/config/routes'

const useNavigateToSearchPage = () => {
  const history = useHistory()

  return (query?: string) => {
    const params = query ? new URLSearchParams({ query }) : null
    history.push({ pathname: client.search, search: params ? params.toString() : '' })
  }
}

export { useNavigateToSearchPage }
